import styled, { css } from 'styled-components';
import { breakpoints } from '../../../styles/screenSizes';

export const GradientText = css`
    background-image: linear-gradient(96.28deg, #0c1a68 0%, #0074fc 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
`;

export const NavContainer = styled.nav`
    width: 100%;
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    backdrop-filter: blur(10px);
    box-shadow: 0px 0px 4px 0px #00000014;

    @media (max-width: ${breakpoints.md}) {
        padding: 8px 12px;
    }
`;

export const Content = styled.div`
    max-width: 1280px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Logo = styled.img`
    height: 18px;

    @media (max-width: ${breakpoints.sm}) {
        height: 17px;
    }
`;

export const NavTagsContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const DropDownIcon = styled.img`
    height: 18px;
    width: 18px;
    filter: invert(43%) sepia(10%) saturate(905%) hue-rotate(182deg) brightness(98%) contrast(83%);
    transition: all 0.3s linear;

    @media (max-width: ${breakpoints.md}) {
        filter: invert(8%) sepia(0%) saturate(0%) hue-rotate(36deg) brightness(92%) contrast(83%);
    }
`;

export const activeStyles = css`
    font-weight: 500;
    color: #101828;
    ${GradientText}

    ${DropDownIcon} {
        filter: invert(30%) sepia(52%) saturate(3749%) hue-rotate(201deg) brightness(98%)
            contrast(103%);
    }
`;

export const NavButton = styled.button`
    all: unset;
    display: flex;
    align-items: center;
    gap: 4px;
    color: rgb(80, 88, 104);
    cursor: pointer;
    user-select: none;
    padding: 28.5px 18px;

    @media (max-width: ${breakpoints.md}) {
        padding: 24px;
        gap: 6px;
        color: #262626;
        font-weight: 500;
        font-size: 14px;
    }

    &:hover {
        ${activeStyles}
        ${GradientText}
    }

    ${({ active }) =>
        active &&
        css`
            ${activeStyles}
            ${DropDownIcon} {
                transform: rotate(-180deg);
            }
        `}
`;
